import { Pencil, UserRound } from "lucide-react";
import type { CandidateProfileData } from "../../../types/candidateProfile.types";

interface AboutCardProps {
  about: string;
  stats: CandidateProfileData["stats"];
  onEdit?: () => void;
}

export default function AboutCard({ about, stats, onEdit }: AboutCardProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100"><UserRound size={20} className="text-blue-600" /></div>
          <div><h2 className="text-lg font-semibold">About Me</h2><p className="text-sm text-slate-500">Professional Summary</p></div>
        </div>
        <button type="button" onClick={onEdit} aria-label="Edit About Me" className="rounded-lg border border-slate-200 p-2 hover:bg-slate-100"><Pencil size={16} /></button>
      </div>
      <div className="mt-5"><p className="whitespace-pre-line text-sm leading-7 text-slate-600">{about}</p></div>
      <div className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-4">
        <div className="rounded-xl bg-slate-50 p-4 text-center"><p className="text-xs uppercase text-slate-500">Experience</p><h3 className="mt-2 text-lg font-bold">{stats.experience}</h3></div>
        <div className="rounded-xl bg-slate-50 p-4 text-center"><p className="text-xs uppercase text-slate-500">Projects</p><h3 className="mt-2 text-lg font-bold">{stats.projects}</h3></div>
        <div className="rounded-xl bg-slate-50 p-4 text-center"><p className="text-xs uppercase text-slate-500">Skills</p><h3 className="mt-2 text-lg font-bold">{stats.skillsCount}</h3></div>
        <div className="rounded-xl bg-slate-50 p-4 text-center"><p className="text-xs uppercase text-slate-500">Status</p><h3 className="mt-2 text-sm font-semibold text-green-600">{stats.status}</h3></div>
      </div>
      <div className="mt-5 flex items-center justify-between border-t pt-4"><span className="text-xs text-slate-500">Last Updated • Profile data</span><button type="button" onClick={onEdit} className="text-sm font-medium text-blue-600 hover:underline">Read More</button></div>
    </div>
  );
}
